import React from 'react';
import { ButtonBase } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import { UiFilterAltFilledSmall } from '@cof/omni-gravity-icons-react';
import { ReactComponent as FilterAltLined } from '../../assets/icons/filter-alt.svg';
import { SEARCH_FILTERS_ALT_TEXT } from '../../assets/copy';

const useStyles = makeStyles((theme) => ({
  button: {
    padding: theme.spacing(0.875),
    borderRadius: theme.spacing(5),
    border: `1px solid ${theme.palette.secondary[65]}`,
    backgroundColor: theme.palette.spoon.white[100],
  },
  buttonActive: {
    border: `1px solid ${theme.palette.spoon.blue[40]}`,
    backgroundColor: theme.palette.spoon.blue[40],
  },
}));

const FilterButton = ({ isActive, onClick }) => {
  const classes = useStyles();
  const buttonClasses = clsx(classes.button, {
    [classes.buttonActive]: isActive,
  });

  return (
    <ButtonBase
      focusRipple
      tabIndex="0"
      onClick={onClick}
      className={buttonClasses}
      aria-label={SEARCH_FILTERS_ALT_TEXT}>
      {isActive ? (
        <FilterAltLined role="img" aria-hidden="true" />
      ) : (
        <UiFilterAltFilledSmall role="img" aria-hidden="true" />
      )}
    </ButtonBase>
  );
};

export default FilterButton;
